// import React, { useState } from "react";
//import styles from './playground1.module.css';
// import Grid from '@mui/material/Unstable_Grid2';
// import Container from '@mui/material/Container';
// import { Height } from "@mui/icons-material";

//import React, { useState } from 'react';
//import { Grid, Paper } from '@mui/material';
//import './App.css'; // Import your CSS file for styling

//!!!!!!!!!!!!!!!!!!!-----------Don't delete especially the last 3 codes.--------!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//-------------------------------------------------------------
/*
import React, { useState, useEffect } from 'react';

function DigitalClock() {
  const [time, setTime] = useState(new Date());
  console.log("time : "+time);

  useEffect(() => {
    const intervalID = setInterval(() => {          //setInterval is a JavaScript function that repeatedly calls a function or executes a code snippet at a specified interval (in milliseconds).
      setTime(new Date());                                                 //setState---------------
    }, 1000);

    return () => clearInterval(intervalID);   // The effect function can optionally return a cleanup function (meh ...by chatgpt). In this case, it returns a function that clears the interval (clearInterval(intervalID)) when the component unmounts or before the effect runs again.
  }, []); // Empty dependency array to run effect only once

  // Options to format date to just the date number
  const options = {
    day: 'numeric',
  };

  // Get the date number of the day that is 2 days after the current date
  const twoDaysAfter = new Date(time);                                      //variable-----------------
  twoDaysAfter.setDate(twoDaysAfter.getDate() + 2);

  return (
    <div>
      <h1>Digital Clock</h1>
      <p>Time: {time.toLocaleTimeString()}</p>
      <p>Current Date: {time.toLocaleDateString(undefined, options)}</p>
      <p>Date 2 Days After: {twoDaysAfter.toLocaleDateString(undefined, options)}</p>
      <p>Current Minute: {time.getMinutes()}</p>
    </div>
  );
}

export default DigitalClock;*/


//-------------------------------------------------------------
/*
import React, { useState, useEffect } from 'react';

function DigitalClock() {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 for Sunday, 1 for Monday, etc.

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const dates = [];
  for (let i = 0; i < 7; i++) {
    const diff = i - dayOfWeek;
    const date = new Date(today);
    date.setDate(today.getDate() + diff);
    dates.push(date.getDate());
  }

  const mondayDate = dates[1];
  const tuesdayDate = dates[2];
  const wednesdayDate = dates[3];
  const thursdayDate = dates[4];
  const fridayDate = dates[5];
  const saturdayDate = dates[6];
  const sundayDate = dates[0]; // Sunday is at the start of the week

  console.log("tutu : "+ [mondayDate, tuesdayDate, wednesdayDate, thursdayDate, fridayDate, saturdayDate, sundayDate]);
  return(
    <div>
      <h1>aaa</h1>
    </div>
  )
}

export default DigitalClock;*/
//------------------------------
/*
import React, { useState, useEffect } from 'react';

const WeekDates = () => {
  const [weekDates, setWeekDates] = useState([]);

  useEffect(() => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 for Sunday, 1 for Monday, etc.

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const diff = i - dayOfWeek;
      const date = new Date(today);
      date.setDate(today.getDate() + diff);
      dates.push(date.getDate());
    }

    setWeekDates(dates);
  }, []); // Empty dependency array ensures this effect runs only once on component mount

  return (
    <div>
      <p>Monday: {weekDates[1]}</p>
      <p>Tuesday: {weekDates[2]}</p>
      <p>Wednesday: {weekDates[3]}</p>
      <p>Thursday: {weekDates[4]}</p>
      <p>Friday: {weekDates[5]}</p>
      <p>Saturday: {weekDates[6]}</p>
      <p>Sunday: {weekDates[0]}</p>
    </div>
  );
};

export default WeekDates;*/

//-------------------------------------



//---------!!!!!!!!!!!!!!!!!!!!!!!!!!!!Below this 3 codes!!!!!!!!!!!!!!!!!!!!!!------------------



//-----------------------------------!!!!!!!!!!!!!!!!!!!!!-----Code-1
//Below code is the dates using datejs node module.
/*
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const WeekDatesComponent = () => {
  const [weekDates, setWeekDates] = useState([]);

  useEffect(() => {
    const today = dayjs();
    const dayOfWeek = today.day(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday

    const dates = [];
    for (let i = 0; i < 7; i++) {
      dates.push(today.subtract(dayOfWeek - i, 'day').format('DD'));
    }

    setWeekDates(dates);
  }, []); // Runs only once on component mount

  return (
    <div>
      <h2>Week Dates</h2>
      <ul>
        {weekDates.map((date, index) => (
          <li key={index}>{date}</li>
        ))}
      </ul>
    </div>
  );
};

export default WeekDatesComponent;*/

//---------------------------------------!!!!!!!!!!!!!!!!-----Code-2
//Below code is NOT yet real-time. IT just updates every 24 hours from the time the component got mounted. Using datejs node module.
//The below code won't update the week dates at exactly at midnight. It will update the week dates every 24 hours from the time the component is mounted. 

/*
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const WeekDatesComponent = () => {
  const [weekDates, setWeekDates] = useState([]);

  useEffect(() => {
    const updateWeekDates = () => {
      const today = dayjs();
      const dayOfWeek = today.day(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday

      const dates = [];
      for (let i = 0; i < 7; i++) {
        //dates.push(today.subtract(dayOfWeek - i, 'day').format('DD'));
        dates.push(today.subtract(dayOfWeek - i, 'second').format('ss'));
      }

      setWeekDates(dates);
    };

    // Update week dates initially
    updateWeekDates();

    // Set interval to update week dates at midnight
    //const intervalId = setInterval(updateWeekDates, 1000 * 60 * 60 * 24); // Update every 24 hours
    const intervalId = setInterval(updateWeekDates, 1000); // Update every 24 hours

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, []); // Runs only once on component mount

  return (
    <div>
      <h2>Week Dates</h2>
      <ul>
        {weekDates.map((date, index) => (
          <li key={index}>{date}</li>
        ))}
      </ul>
    </div>
  );
};

export default WeekDatesComponent;*/

//------------------------------------------!!!!!!!!!!!!!!!!!!!!!----Code-3
//The below code is actually real time and update the dates exactly at midnight. Even though updating only on saturday/sunday evening just before midnight will reflect in the UI because actually it just need to update every saturday/sunday midnight.
/*
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const WeekDatesComponent = () => {
  const [weekDates, setWeekDates] = useState([]);

  useEffect(() => {
    const updateWeekDatesAtMidnight = () => {
      const now = dayjs();
      const millisecondsUntilMidnight = dayjs(now).endOf('day').diff(now);

      // Update week dates initially
      updateWeekDates();

      // Set timeout to update week dates at midnight
      const timeoutId = setTimeout(() => {
        updateWeekDatesAtMidnight();
      }, millisecondsUntilMidnight);
      
      // Clear timeout on component unmount
      return () => clearTimeout(timeoutId);
    };

    const updateWeekDates = () => {
      const today = dayjs();
      const dayOfWeek = today.day(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday

      const dates = [];
      for (let i = 0; i < 7; i++) {
        dates.push(today.subtract(dayOfWeek - i, 'day').format('DD'));
      }

      setWeekDates(dates);
    };

    // Start updating the week dates at midnight
    updateWeekDatesAtMidnight();
  }, []); // Runs only once on component mount

  return (
    <div>
      <h2>Week Dates</h2>
      <ul>
        {weekDates.map((date, index) => (
          <li key={index}>{date}</li>
        ))}
      </ul>
    </div>
  );
};

export default WeekDatesComponent;*/



//-------------------------
//search bar creation.
/*
import React, { useState } from 'react';

function SearchBar({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch(searchTerm);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleChange}
      />
      <button type="submit">Search</button>
    </form>
  );
}

export default SearchBar;*/

//---------------------------
//heartbeat
/*
import React, { useState, useEffect } from 'react';
//import './Heartbeat.css';

const Heartbeat = () => {
  const [beat, setBeat] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setBeat(prevBeat => !prevBeat);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`heart-container ${beat ? 'beat' : ''}`}>
      <div className="heart"></div>
    </div>
  );
};

export default Heartbeat;*/

//-----------------------------
//Feedback form
/*
import React, { useState } from 'react';

const FeedbackBox = () => {
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can handle the submission of feedback here, such as sending it to a server
    console.log('Subject:', subject);
    console.log('Description:', description);
    // Optionally, you can clear the input fields after submission
    setSubject('');
    setDescription('');
  };

  return (
    <div className="feedback-box">
      <h2>Send Feedback</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="subject">Subject:</label>
          <input
            type="text"
            id="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">Description:</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          ></textarea>
        </div>
        <button type="submit">Submit Feedback</button>
      </form>
    </div>
  );
};

export default FeedbackBox;*/

//---------------------------------------------
//Beautiful search bar 1.
/*
import React, { useState } from 'react';
//import './SearchBar.css'; // import your CSS file

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle search logic here, like fetching data based on the search term
    console.log('Search term:', searchTerm);
  };

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleChange}
        className="search-input"
      />
      <button type="submit" className="search-button">
        <i className="fas fa-search"></i>
      </button>
    </form>
  );
};

export default SearchBar;*/

//----------------------------------------------
//Beautiful search bar 2.
/*
import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const SearchBar = ({ placeholder, onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    //onSearch(value); // Pass the search term to the parent component
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleChange}
        className="search-input"
      />
      <FaSearch className="search-icon" />
    </div>
  );
};

export default SearchBar;*/

//---------------------------------------------------

/*
import React from 'react';
//import './GradientBackground.css'; // Import your CSS file for styling

function GradientBackground(){
  return (
    <div className="gradient-background">
      { Your content goes here }
      aa
    </div>
  );
};

export default GradientBackground;
*/








//--------------------------------------------
// import React, { useState, useRef, useEffect } from 'react';
// import ReactDOM from 'react-dom';

// const PressComponent = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const pressRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (pressRef.current && !pressRef.current.contains(event.target)) {
//         setIsVisible(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   return (
//     <div>
//       <p onClick={() => setIsVisible(true)}>Press</p>
//       {isVisible && (
//         <div
//           ref={pressRef}
//           style={{
//             width: '300px',
//             height: '400px',
//             backgroundColor: 'lightblue',
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             zIndex: 9999,
//           }}
//         >
//           {/* Content of the div */}
//           Click outside this box to close.
//         </div>
//       )}
//     </div>
//   );
// };

// export default PressComponent;






//----------------------------------
// import styles from './playground1.module.css';
// import React, { useState } from 'react';
// import { FaSearch } from 'react-icons/fa';
// import Playground2 from './Playground2';

// const Playground1 = () => {

//   return (
//     <div className={styles.example_div}>
//       <Playground2 className={styles.example_component_left_margin}/>
//     </div>
//   );
// };

// export default Playground1;
//------------------------------------




// import { useState, useEffect } from "react";

// const MyComponent = () => {
//   const [currentTimeInSeconds, setCurrentTimeInSeconds] = useState(0);

//   useEffect(() => {
//     const getSecondsForDay = () => {
//       const now = new Date();
//       const seconds =
//         now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
//       return seconds;
//     };

//     // Update the time every second
//     const intervalId = setInterval(() => {
//       const currentSecond = getSecondsForDay();
//       setCurrentTimeInSeconds(currentSecond);
//       console.log("currentSecond: " + currentSecond);
//     }, 1000);

//     // Cleanup interval when component unmounts
//     return () => clearInterval(intervalId);
//   }, []);

//   return <div>Current Time in Seconds: {currentTimeInSeconds}</div>;
// };

// export default MyComponent;








// import React from 'react';
// import styles from './playground1.module.css';

// const Needle = () => {
//   return (
//     <div className={styles.needleContainer}>
//       <div className={styles.triangle}></div>
//       <div className={styles.line}></div>
//     </div>
//   );
// };

// export default Needle;











// import React, { useState } from 'react';
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css'; // Import the calendar styles

// const CalendarToggle = () => {
//   const [showCalendar, setShowCalendar] = useState(false);

//   const toggleCalendar = () => {
//     setShowCalendar(!showCalendar);
//   };

//   return (
//     <div>
//       <p onClick={toggleCalendar} style={{ cursor: 'pointer', color: 'blue' }}>
//         Calendar
//       </p>
//       {showCalendar && (
//         <div>
//           <Calendar />
//         </div>
//       )}
//     </div>
//   );
// };

// export default CalendarToggle;














// import React, { useState } from 'react';
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
// import './playground1.css'; // Create this file to add custom styles

// function CustomCalendar() {
//   const [date, setDate] = useState(new Date());

//   const handleDateChange = (newDate) => {
//     setDate(newDate);
//   };

//   return (
//     <div className="calendar-container">
//       <Calendar onChange={handleDateChange} value={date} />
//       <p className="selected-date">
//         Selected date: {date.toLocaleDateString('en-GB', {
//           day: 'numeric',
//           month: 'long',
//           year: 'numeric',
//         })}
//       </p>
//     </div>
//   );
// }

// export default CustomCalendar;










// Reset password stuff.
/*
import React, { useState } from "react";
import axios from "axios";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match!");
      return;
    }

    try {
      setErrorMessage(""); // Clear any previous errors
      const response = await axiosInstance.post("/reset-password", { password });
      setSuccessMessage("Password reset successful!");
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "An error occurred!");
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Reset your password</h2>
      <form onSubmit={handleResetPassword} style={{ width: "300px", margin: "auto" }}>
        <div style={{ marginBottom: "15px" }}>
          <input
            type="password"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
            required
          />
          <small>At least 6 characters</small>
        </div>
        <div style={{ marginBottom: "15px" }}>
          <input
            type="password"
            placeholder="New password, again"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
            required
          />
        </div>
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
        <button
          type="submit"
          style={{
            backgroundColor: "purple",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Reset password
        </button>
      </form>
    </div>
  );
}

export default ResetPassword;

*/
















// import React, { useState } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

// const DatePickerToggle = () => {
//   const [selectedDate, setSelectedDate] = useState(null);

//   return (
//     <div>
//       <p>Click to select a date</p>
//       <DatePicker
//         selected={selectedDate}
//         onChange={(date) => setSelectedDate(date)}
//         inline // Displays the calendar inline
//       />
//     </div>
//   );
// };

// export default DatePickerToggle;














// import React from 'react';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';

// const localizer = momentLocalizer(moment);
// const myEventsList = [
//   { title: 'Event 1', start: new Date(), end: new Date() }
// ];

// const BigCalendarToggle = () => (
//   <div>
//     <Calendar
//       localizer={localizer}
//       events={myEventsList}
//       startAccessor="start"
//       endAccessor="end"
//       style={{ height: 500 }}
//     />
//   </div>
// );

// export default BigCalendarToggle;















// import React, { useState } from 'react';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

// const CustomDatePicker = () => {
//   const [selectedDate, setSelectedDate] = useState(null);

//   // Set today’s date when the "Today" button is clicked
//   const handleToday = () => {
//     setSelectedDate(new Date());
//   };

//   // Clear the selected date
//   const handleClear = () => {
//     setSelectedDate(null);
//   };

//   return (
//     <div>
//       <DatePicker
//         selected={selectedDate}
//         onChange={date => setSelectedDate(date)}
//         isClearable // Adds a built-in clear button
//         placeholderText="Select a date"
//       />
//       <div style={{ marginTop: '10px' }}>
//         <button onClick={handleToday}>Today</button>
//         <button onClick={handleClear} style={{ marginLeft: '10px' }}>Clear</button>
//       </div>
//     </div>
//   );
// };

// export default CustomDatePicker;



















/*


import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Button, Slider, Typography } from "@mui/material";
//import { getCroppedImg } from "./cropImage"; // Helper function (code below)
import "./ProfilePhotoCropper.css"; // Add your styles here





const ProfilePhotoCropper = () => {
  const getCroppedImg = (imageSrc, crop) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
  
        canvas.width = crop.width;
        canvas.height = crop.height;
  
        ctx.drawImage(
          image,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          crop.width,
          crop.height
        );
  
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          blob.name = "cropped.jpeg";
          resolve(URL.createObjectURL(blob));
        }, "image/jpeg");
      };
      image.onerror = reject;
    });
  };
  





  const [imageSrc, setImageSrc] = useState(null); // Original image
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null); // Cropped area details
  const [croppedImage, setCroppedImage] = useState(null); // Final cropped image

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCrop = useCallback(async () => {
    try {
      const croppedImg = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedImage(croppedImg); // Save the cropped image as a preview
    } catch (error) {
      console.error("Crop failed:", error);
    }
  }, [imageSrc, croppedAreaPixels]);

  return (
    <div className="container">
      <Typography variant="h5">Upload and Crop Your Profile Photo</Typography>

      {!imageSrc ? (
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          style={{ margin: "20px 0" }}
        />
      ) : (
        <div className="crop-container">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1} // 1:1 aspect ratio for profile pictures
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
          <div className="controls">
            <Typography>Zoom</Typography>
            <Slider
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              onChange={(e, zoomValue) => setZoom(zoomValue)}
            />
            <Button variant="contained" color="primary" onClick={handleCrop}>
              Crop Image
            </Button>
          </div>
        </div>
      )}

      {croppedImage && (
        <div className="cropped-image-preview">
          <Typography variant="h6">Cropped Image Preview:</Typography>
          <img src={croppedImage} alt="Cropped" style={{ width: "150px", height: "150px" }} />
        </div>
      )}
    </div>
  );
};

export default ProfilePhotoCropper;
*/














import React, { useState, useEffect, useCallback } from "react"; // Import React and hooks for state and callbacks
import Cropper from "react-easy-crop"; // Import the Cropper component for cropping functionality
import { Button, Slider, Typography } from "@mui/material"; // Import UI components from Material-UI
import { getCroppedImg } from "./cropImage"; // Import helper function to extract the cropped image
import "./ProfilePhotoCropper.css"; // Import custom styles
import { axiosInstance, axiosInstanceForImage } from "../../lib/axiosInstance";

const ProfilePhotoCropper = () => {



  





  // State to store the uploaded image source (as a data URL)
  const [imageSrc, setImageSrc] = useState(null);

  // State to manage the cropping position (x and y coordinates)
  const [crop, setCrop] = useState({ x: 0, y: 0 });

  // State to manage the zoom level of the image
  const [zoom, setZoom] = useState(1);

  // State to store the pixel coordinates and dimensions of the cropped area
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // State to store the final cropped image (as a URL)
  const [croppedImage, setCroppedImage] = useState(null);

  const [uploadMessage, setUploadMessage] = useState(""); // State for upload status message




  // Fetch default profile image from the API
  useEffect(() => {
    async function fetchDefaultImage() {
      try {
        const response = await axiosInstanceForImage.get("/profile/image?type=profile");
        const imageBlob = new Blob([response.data], { type: response.headers["content-type"] });
        const imageUrl = URL.createObjectURL(imageBlob); // Create a URL for the image
        setImageSrc(imageUrl); // Set the default image as the source
      } catch (error) {
        console.error("Failed to fetch default image:", error); // Log error details
      }
    }
    fetchDefaultImage(); // Call the function when the component mounts
  }, []);




  // Callback triggered when cropping is completed, updates the cropped area state
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels); // Store pixel data for further processing
  }, []);

  // Function to handle image upload from the user's device
  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Get the uploaded file
    if (file) {
      const reader = new FileReader(); // Use FileReader to read the file
      reader.onload = () => {
        setImageSrc(reader.result); // Set the image source as a base64-encoded string
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  // Function to handle the cropping process and generate the final cropped image
  const handleCrop = useCallback(async () => {
    try {
      // Use the helper function to crop the image using the source and cropped area
      const croppedImg = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedImage(croppedImg); // Store the resulting cropped image URL
    } catch (error) {
      console.error("Crop failed:", error); // Log errors in case cropping fails
    }
  }, [imageSrc, croppedAreaPixels]);



  const handleUpload = async () => {
    if (!croppedImage) {
      setUploadMessage("No cropped image available to upload."); // Warn if no cropped image
      return;
    }

    const formData = new FormData();
    formData.append("profileImage", croppedImage); // Append the cropped image blob

    try {
      const response = await axiosInstanceForImage.post("/profile/upload");
      setUploadMessage("Image uploaded successfully!"); // Show success message
      //console.log("Upload response:", response.data);
    } catch (error) {
      console.error("Upload failed:", error); // Log error details
      setUploadMessage("Image upload failed. Please try again."); // Show error message
    }
  };

  

  return (
    <div className="container"> {/* Main container for the cropper UI */}
      <Typography variant="h5">Upload and Crop Your Profile Photo</Typography> {/* Header */}

      {!imageSrc ? ( // If no image is uploaded, show the file input field
        <input
          type="file" // Accept files from the user's system
          accept="image/*" // Only allow image files
          onChange={handleImageUpload} // Trigger the image upload handler on change
          style={{ margin: "20px 0" }} // Add some margin
        />
      ) : ( // If an image is uploaded, show the cropper UI
        <div>
          <div className="crop-container"> {/* Container for the cropping tool */}
            <Cropper
              image={imageSrc} // Image source to be cropped
              crop={crop} // Current crop position
              zoom={zoom} // Current zoom level
              aspect={1} // Aspect ratio (1:1 for profile pictures)
              onCropChange={setCrop} // Update crop position when changed
              onZoomChange={setZoom} // Update zoom level when changed
              onCropComplete={onCropComplete} // Trigger callback when cropping is completed
            />
          </div>
          <div className="controls"> {/* Controls for zoom and crop actions */}
            <Typography>Zoom</Typography> {/* Label for zoom slider */}
            <Slider
              value={zoom} // Current zoom level
              min={1} // Minimum zoom
              max={3} // Maximum zoom
              step={0.1} // Step size for zoom adjustments
              onChange={(e, zoomValue) => setZoom(zoomValue)} // Update zoom state on slider change
            />
            <Button
              variant="contained" // Styled button
              color="primary" // Primary color
              onClick={handleCrop} // Trigger the crop handler on click
            >
              Crop Image
            </Button>
          </div>
        </div>
      )}

      {croppedImage && ( // If a cropped image is generated, show its preview
        <div className="cropped-image-preview"> {/* Container for the preview */}
          <Typography variant="h6">Cropped Image Preview:</Typography> {/* Preview header */}
          <img
            src={croppedImage} // Display the cropped image
            alt="Cropped" // Alternate text for the image
            style={{ width: "150px", height: "150px" }} // Set dimensions for the preview
          />
        </div>
      )}
    </div>
  );
};

export default ProfilePhotoCropper; // Export the component for use

